import { defineComponent, watchEffect } from "vue";
import { RouterView } from "vue-router";
import { useModeStore } from "./store";
import "./cssreset.css";

export default defineComponent({
  name: "App",
  props: {},
  setup() {
    const modeStore = useModeStore();
    const uiStyle = localStorage.getItem("uiStyle");
    modeStore.setUiStyle(uiStyle === "elder" ? "elder" : "normal");
    const changUiStyle = (uiStyle) => {
      if (uiStyle === "elder") {
        document.querySelector("html").setAttribute("class", "__elder");
      } else {
        document.querySelector("html").setAttribute("class", "__normal");
      }
    };
    watchEffect(() => {
      changUiStyle(modeStore.uiStyle);
    });

    return () => {
      return <RouterView></RouterView>;
    };
  },
});
